import { Button, TableCell, TableRow } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'
import { useCallback, useMemo } from 'react'
import { DELETE_CONFIRM } from '../../constants/form'
import { deleteShipment } from '../../store/actions/shipmentAction'

const ShipmentList = ({ shipment }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)

    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteShipment(id))
            }
        },
        [dispatch]
    )

    const shippedItemQty = useMemo(() => {
        return (
            shipment?.shipmentorderitems?.reduce(
                (total, shipment) => total + shipment.quantity,
                0
            ) || 0
        )
    }, [shipment])

    const receivedItemQty = useMemo(() => {
        return (
            shipment?.shipmentorderitems?.reduce(
                (total, shipment) =>
                    shipment.confirm === 1 ? total + shipment.stock : total,
                0
            ) || 0
        )
    }, [shipment])

    return (
        <>
            <TableRow>
                <TableCell>{shipment.shipmentId}</TableCell>
                <TableCell>{shipment.etd}</TableCell>
                <TableCell>{shipment.eta}</TableCell>
                <TableCell>{shippedItemQty}</TableCell>
                <TableCell>{receivedItemQty}</TableCell>

                <TableCell>
                    <div className="button-box">
                        <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() =>
                                checkUserRole(
                                    userInfo,
                                    roleList,
                                    roleListId.SHIPMENT,
                                    roleType.READ
                                )
                                    ? navigate(`/shipment/${shipment.id}`)
                                    : alert('Not Permit User')
                            }
                        >
                            Info
                        </Button>

                        <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() =>
                                checkUserRole(
                                    userInfo,
                                    roleList,
                                    roleListId.SHIPMENT,
                                    roleType.DELETE
                                )
                                    ? handleDelete(shipment.id)
                                    : alert('Not Permit User')
                            }
                        >
                            Delete
                        </Button>
                    </div>
                </TableCell>
            </TableRow>
        </>
    )
}

export default ShipmentList
